<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Branchs'"
        :buttons="[
          {
            title: 'Add Branch',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'Branchs'"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
        @user="userShow = $event"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
      <users
        v-if="userShow != null"
        :branch="userShow"
        @close="userShow = null"
      ></users>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
import users from "./users/main";
export default {
  name: "Branchs",
  components: { upsert, users },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "CountryId",
          field: "CountryId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "City",
          field: "City",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Town",
          field: "Town",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Title",
          field: "Title",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "TaxOffice",
          field: "TaxOffice",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "TaxNumber",
          field: "TaxNumber",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Address",
          field: "Address",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Person",
          field: "Person",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Email",
          field: "Email",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Phone",
          field: "Phone",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "Commission",
          field: "Commission",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 120,
        },
        {
          headerName: "",
          type: "action",
          width: 115,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-primary",
              text: "Users",
              emit: "user",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
          cellRenderer: this.$BtnCellRenderer,
          cellRendererParams: {
            clicked: function(field) {
              this.$emit(field.emit, field.data);
            },
          },
        },
      ],
      data: null,
      addShow: false,
      updateShow: null,
      userShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Branchs`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the worker named " + item.Name + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Branchs/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The branch has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
